// extracted by mini-css-extract-plugin
module.exports = {"center":"_6b808d6"};